import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';

import ContactCourseCard from './ContactCourseCard';
import CourseHeader from './CourseHeader';
import CourseStadistics from './CourseStadistics';
import CoursesList from './CoursesList';
import CtaCourseCard from './CtaCourseCard';

import Container from 'react-bootstrap/Container';

export class CoursesLayout extends Component {
	render() {
		const { courses } = this.props;

		return (
			<div style={{ marginTop: 70 }} onLoad={window.scrollTo(0, 0)}>
				<CourseHeader />
				<div className='mx-md-5 mb-4 px-md-5'>
					<Container className='text-center my-3'>
						<h1 style={{ color: '#3367FF' }}>Capacitación</h1>
						<div className='d-flex justify-content-center'>
							<div className='divider' />
						</div>
					</Container>
					<CtaCourseCard />
					<Container className='text-center my-3'>
						<h5 className='mx-2' style={{ color: '#3367FF' }}>
							Empieza a capacitarte con nuestros cursos
						</h5>
					</Container>
					<CoursesList courses={courses} />
					<ContactCourseCard />
					<CourseStadistics />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		courses: state.firestore.ordered.courses,
	};
};

export default compose(
	connect(mapStateToProps),
	firestoreConnect([
		{ collection: 'courses', limit: 6, orderBy: ['createdAt', 'desc'] },
	])
)(CoursesLayout);
